import styles from "./accountlistfilter.module.css";
import { Link } from "react-router-dom";
import { ArrowRight, Filter, Plus, Search } from "react-feather";
import { useState } from "react";
import FilterAutocomplete from "../../../../components/FilterAutocomplete";

const TYPE_OPTIONS = [
    { value: "Tuya", label: "Tuya" },
    { value: "TTLock", label: "TTLock" },
];

const AccountListFilter = ({ setShowTuyaAddFormNew, setFilterData, setPage, propertyList, filterData }) => {
    const [showFilter, setShowFilter] = useState(false);

    const apartmentList = propertyList?.find(i => i.value === filterData.property)?.apartments || [];

    const changeFilter = (key, value) => {
        setFilterData((prev) => ({ ...prev, [key]: value }));
        setPage(0);
    }

    return (<div className={`${styles.SearchFilterSec}`}>
        <div className={`${styles.SearchCon}`}>
            <div className={`${styles.SearchConSec}`}>
                <Search />
                <input type="text" placeholder="Search" onChange={(e) => {
                    setFilterData((prev) => { return { ...prev, searchKey: e.target.value }; });
                    setPage(0);
                }} />
            </div>
        </div>
        <div className={`${styles.FilterSec}`}>
            <div className={!showFilter ? `${styles.FilterFieldSec}` : `${styles.FilterFieldSec} ${styles.Open}`}>
                <p className={`${styles.FilterTitle}`}>
                    Filters
                    <span onClick={(e) => setShowFilter(false)}>
                        <ArrowRight />
                    </span>
                </p>
                <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}>
                    <FilterAutocomplete
                        label="Property"
                        options={propertyList}
                        value={filterData?.property}
                        onChange={(value) => {
                            setFilterData((prev) => ({ ...prev, property: value, apartment: '' }));
                            setPage(0);
                        }}
                    />
                </div>
                <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}>
                    <FilterAutocomplete
                        label="Apartment"
                        options={apartmentList}
                        value={filterData?.apartment}
                        noOptionsText={filterData?.property !== "" ? "No apartments found" : "Select property first"}
                        onChange={(value) => changeFilter("apartment", value)}
                    />
                </div>
                <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}>
                    <FilterAutocomplete
                        label="Type"
                        options={TYPE_OPTIONS}
                        value={filterData?.type}
                        onChange={(value) => changeFilter("type", value)}
                    />
                </div>
            </div>
            <Link className={`${styles.FilterBu}`} onClick={(e) => setShowFilter(true)}>
                <Filter />
            </Link>
            <Link className={`${styles.AddNoteBu}`} onClick={(e) => setShowTuyaAddFormNew(true)}>
                <Plus /> <span>IoT Account</span>
            </Link>
        </div>
    </div >)
}


export default AccountListFilter;